import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from '@environments/environment';
import { commonImages } from '@images/common-images';

@Component({
  selector: 'app-listing-preview',
  templateUrl: './preview-listing.component.html',
  styleUrls: ['./preview-listing.component.scss'],
})
export class ListingPreviewComponent implements OnInit, OnChanges {
  @Input() listingDetails: any;
  @Input() displayedImages: any;
  @Input() currentIndex: any;
  @Input() imagesPath: any;
  @Input() shortDetails: any;
  @Input() is_agentModel: boolean = false;
  @Input() isLongDescription: boolean = false;
  @Input() imagesLiteHeight: number;
  @Input() imagesLiteWidth: number;
  @Input() imageHeight: number;

  @Input() dayAgo!: (data?: any) => void;
  @Input() getTimed!: (data?: any) => void;
  @Input() adminView!: (data?: any) => void;
  @Input() goToPrevious!: (data?: any) => void;
  @Input() getSliderImageByPath!: (data?: any) => void;
  @Input() getImagePath!: (data?: any) => void;
  @Input() goToNext!: (data?: any) => void;

  S3Path = environment.S3 + '/';
  common_images = commonImages;

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['listingDetails'] && !changes['listingDetails'].firstChange) {
      console.log('Initial listingDetails :>> ', this.listingDetails);

      // If you need to trigger any logic when it updates, do it here
    }
  }

  getDisplayPrice(): { value: any; isCurrency: boolean } {
    if (!this.listingDetails) {
      return { value: '', isCurrency: false };
    }

    // If display_price exists → return as plain text
    if (this.listingDetails.display_price) {
      return {
        value: this.listingDetails.display_price,
        isCurrency: false,
      };
    }

    const isRental = this.listingDetails.property_status === 'For Lease' || this.listingDetails.property_status === 'Leased';

    return {
      value: isRental ? this.listingDetails.rentalPerWeek : this.listingDetails.value,
      isCurrency: true,
    };
  }

  getTotalCarSpaces(): number {
    if (!this.listingDetails) return 0;

    return (this.listingDetails.garage || 0) + (this.listingDetails.car_port || 0) + (this.listingDetails.open_spaces || 0);
  }

  getLandAreaDisplay(): string {
    if (!this.listingDetails?.land_area) return '';

    const area = this.listingDetails.land_area;
    const type = this.listingDetails.land_area_type;

    if (type === 'm2') {
      return `${area} m²`;
    }

    return `${area} ${type || ''}`;
  }

  getBuildingAreaDisplay(): string {
    if (!this.listingDetails?.building_area) return '';

    const area = this.listingDetails.building_area;
    const type = this.listingDetails.building_area_type;

    if (type === 'm2') {
      return `${area} m²`;
    }

    return `${area} ${type || ''}`;
  }

  hasAnyAgent(): boolean {
    return !!(this.listingDetails?.agent || this.listingDetails?.secondaryagent);
  }

  isExpanded = false;

  toggleDescription(): void {
    this.isExpanded = !this.isExpanded;
  }

  get descriptionContent(): string {
    if (!this.isLongDescription) {
      return this.listingDetails?.description_garax;
    }

    return this.isExpanded ? this.listingDetails?.description_garax : this.shortDetails;
  }
}
